// tslint:disable: variable-name
export class ManageTicketStatusModel {
  GameNumber: number;
  BarcodeACN: number;
  BarcodeText: string;
  Area: string;
  Row: string;
  Seat: string;
  Status: number;
  Balance: number;
  Date: Date;

  constructor(
    gameNumber: number,
    barcodeAcn: number,
    barcodeText: string,
    area: string,
    row: string,
    seat: string,
    status: number,
    balance: number,
    date: Date
  ) {
    this.GameNumber = gameNumber;
    this.BarcodeACN = barcodeAcn;
    this.BarcodeText = barcodeText;
    this.Area = area;
    this.Row = row;
    this.Seat = seat;
    this.Status = status;
    this.Balance = balance;
    this.Date = date;
  }
}
